import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class CookieUtilsService {
  constructor(private cookieService: CookieService) {}

  public getCookie(cookieName: string, property: string = null) {
    if (!this.cookieService.get(cookieName)) {
      return false;
    }
    try {
      const cookie = JSON.parse(this.cookieService.get(cookieName));
      if (!property) {
        return cookie;
      }
      if (property && cookie[property]) {
        return cookie[property];
      }
      if (property && !cookie[property]) {
        return false;
      }
    } catch (e) {
      return this.cookieService.get(cookieName);
    }
  }

  public setCookie(cookieName: string, value, expiredDate: Date = null, domain: string = null) {
    const userAgent = navigator.userAgent.toLowerCase();
    const isWebkitBrowser = userAgent.indexOf('chrome') > -1 || userAgent.indexOf('safari') > -1;
    const sameSite = isWebkitBrowser ? 'Strict' : 'None';
    value = typeof value !== 'string' ? JSON.stringify(value) : value;
    if (!expiredDate) {
      expiredDate = new Date();
      expiredDate.setDate(expiredDate.getDate() + 2);
    }
    this.cookieService.set(cookieName, value, expiredDate, '/', domain, false, sameSite);
  }

  public deleteCookie(cookieName: string) {
    this.cookieService.delete(cookieName);
  }
}
